// import { gsap } from "gsap/gsap-core";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

/* global gsap, ScrollTrigger: false */

gsap.registerPlugin(ScrollTrigger);

import { getSiblings } from "../../helpers";

export default class MegaSlider {
	constructor(sliderEl) {
		if (!sliderEl) return;

		if (!window.matchMedia("(min-width: 1200px)").matches) return;

		this.megaSlider = sliderEl;
		this.buttonItems = Array.from(
			this.megaSlider.querySelectorAll(".item-button")
		);
		this.map = this.megaSlider.querySelector("#svg-map");
		this.imageWrapper = this.megaSlider.querySelector(".image-wrapper");
		this.images = Array.from(this.imageWrapper.querySelectorAll(".item-image"));
		this.textsWrapper = this.megaSlider.querySelector(".texts");

		this.init();
		this.events();
	}

	init() {
		this.slideTo.bind(this)(0);

		gsap.to(".section-mega-slider", {
			scrollTrigger: {
				trigger: ".section-mega-slider",
				// markers: true,
				start: "top 80px",
				scrub: true,
				pin: true,
				// pinSpacing: false,
				onUpdate: (self) => {
					this.changeSlideToPercent.bind(this)(self.progress.toFixed(2) * 100);
				},
			},
		});
		Array.from(this.map.querySelectorAll(`.map-pin`)).map(pin => {
			pin.classList.add('cursor-pointer')
			pin.addEventListener('click', () => {
				if (pin.id === 'map-pin1') {
					document.getElementById('btn-0').click();
				} else if (pin.id === 'map-pin2') {
					document.getElementById('btn-1').click();
				} else if (pin.id === 'map-pin3') {
					document.getElementById('btn-2').click();
				}
			})
		})
	}

	slideTo(index) {
		if (!this.buttonItems[index]) return;
		this.buttonItems[index].classList.add("active");
		const titleSiblings = getSiblings(this.buttonItems[index]);
		titleSiblings &&
			titleSiblings.length > 0 &&
			titleSiblings.map((s) => s.classList.remove("active"));
		this.activateMapPin(index + 1);

		let currentImage = this.images[index];
		currentImage.classList.add("active");
		const imageSiblings = getSiblings(currentImage);
		imageSiblings && imageSiblings.map((s) => s.classList.remove("active"));

		this.textsWrapper.style.setProperty(
			"--copy-transform",
			`-${(index + 1) * 50}px`
		);
	}

	clickItemHandler(event) {
		this.slideTo.bind(this)(this.buttonItems.indexOf(event.currentTarget));
	}

	events() {
		this.buttonItems.map(($itemText, index) => {
			$itemText.addEventListener(
				"click",
				this.clickItemHandler.bind(this),
				false
			);
		});
	}

	deactivateMapPins() {
		Array.from(this.map.querySelectorAll(".map-circle-pin")).map((el, idx) =>
			this.deactivateMapPin.bind(this)(idx + 1)
		);
	}

	deactivateMapPin(pinNumber = 0) {
		if (0 > parseInt(pinNumber)) return;
		this.map.querySelector(`#circle-pin${pinNumber}`).style.opacity = "0";
		this.map.querySelector(`#map-pin${pinNumber}`).classList.remove("active");
	}

	activateMapPin(pinNumber = 0) {
		if (!this.map || 0 > parseInt(pinNumber)) return;
		this.deactivateMapPins.bind(this)();
		this.map.querySelector(`#circle-pin${pinNumber}`).style.opacity = "0.5";
		this.map.querySelector(`#map-pin${pinNumber}`).classList.add("active");
	}

	changeSlideToPercent(percent = 0) {
		let idx = Math.floor(percent / (100 / (this.buttonItems.length + 1)));
		this.slideTo.bind(this)(idx);
	}


}
